import { useEffect } from 'react';

export function useAutoSelectFirstSummary({
  firstSummaryId,
  selectedSummaryId,
  setSearchParams,
}: {
  firstSummaryId: string | undefined;
  selectedSummaryId: string | null;
  setSearchParams: (
    params: URLSearchParams | ((prev: URLSearchParams) => URLSearchParams),
    options?: { replace?: boolean }
  ) => void;
}) {
  useEffect(() => {
    if (!firstSummaryId || selectedSummaryId) return;

    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        if (!next.get('summaryId')) {
          next.set('summaryId', firstSummaryId);
        }
        return next;
      },
      { replace: true }
    );
  }, [firstSummaryId, selectedSummaryId, setSearchParams]);
}
